import { h } from "preact"
import style from "./Header.sass"
import PricePanel from "../PricePanel/PricePanel"
import PropTypes from "prop-types"
import wompiLogo from "../../assets/icons/logo-wompi-negro.svg"

export default function Header({ store }) {
  const { transaction } = store.$state

  return (
    <div className={style.headerWrapper}>
      <div className={style.header}>
        <div className={style.leftSide}>
          <img src={wompiLogo} alt="Wompi" className={style.wompiLogo} />
        </div>
        <div className={style.rightSide} />
      </div>
      {transaction?.merchant && (
        <div className={style.merchantContainer}>
          <PricePanel store={store} />
        </div>
      )}
    </div>
  )
}

Header.propTypes = {
  store: PropTypes.shape({
    $state: PropTypes.shape({
      thirdPartyCheckout: PropTypes.string,
      transaction: PropTypes.shape({
        expirationTime: PropTypes.string,
        expirationTimeRetry: PropTypes.string,
      }),
      merchant: PropTypes.shape({
        logoUrl: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  }),
}
